module.exports = __webpack_public_path__ + "img/logo-small-dark.e82eec9f.svg";